import { Announcement } from '@saleshandy/icons';
import React from 'react';
import { Spinner } from 'react-bootstrap';

type NewLeadFinderBannerProps = {
  onSwitchClick: () => void;
  isLoading?: boolean;
};

const NewLeadFinderBanner: React.FC<NewLeadFinderBannerProps> = ({
  onSwitchClick,
  isLoading = false,
}) => (
  <div className="new-lead-finder-banner">
    <div className="new-lead-finder-banner__content">
      <div className="new-lead-finder-banner__icon-container">
        <div className="new-lead-finder-banner__icon-inner">
          <Announcement height={12} width={12} color="#7C3AED" />
        </div>
      </div>
      <div className="new-lead-finder-banner__text-wrapper">
        <span className="new-lead-finder-banner__text">
          The New Lead Finder is live! Experience 10x faster searches, smarter
          filters, and much more.
        </span>
        <button
          type="button"
          className="new-lead-finder-banner__link"
          onClick={onSwitchClick}
          disabled={isLoading}
        >
          {isLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            'Switch to New'
          )}
        </button>
      </div>
    </div>
  </div>
);

export default NewLeadFinderBanner;
